export function emptySnapshot() {
    return { weeks: [], issues: [], packages: [], payments: [], assign: {}, misc: {}, users: [] };
}
//# sourceMappingURL=types.js.map